import styled from "styled-components";

export const InstructionsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 6px;
    position: relative;
`

export const InstructionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
`

export const InstructionsHeader = styled.div`
	display: flex;
	flex-direction: column;
	gap: 16px;
`

export const TextDescriptionContainer = styled.div`
    display: flex;
`

export const EnhanceWrapper = styled.div `
    display: flex;
    justify-content: center;
    position: relative;
`